import { Outlet } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import DashboardLayout from '@layouts/dashboardLayout/Dashboard.layout';
import InformationInquiryPage from 'pages/account-info/information-inquiry';
import ChangePasswordPage from 'pages/account-info/change-password';
import WithAuth from 'shared/components/hocs/with-auth';

export const ACCOUNT_INFO_ROUTES = {
  path: '',
  element: (
    <WithAuth>
      <Outlet />
    </WithAuth>
  ),
  children: [
    {
      path: ROUTES.ACCOUNT_INFO.INFO_INQUIRY.path,
      element: (
        <DashboardLayout>
          <InformationInquiryPage />
        </DashboardLayout>
      ),
    },
    {
      path: ROUTES.ACCOUNT_INFO.CHANGE_PASSWORD.path,
      element: (
        <DashboardLayout>
          <ChangePasswordPage />
        </DashboardLayout>
      ),
    },
  ],
};
